// Bloque «picker»: elegir, p. ej., a cuál hijo se refiere la página. Lo
// elegido va en la URL (`picks`) y los demás bloques se vuelven a pedir.
// Pocas opciones: botones; muchas: una lista desplegable nativa.

import { cn } from "@/lib/utils";
import type { SiteBlockOf } from "../values";
import { siteFieldClass } from "./shared";

const MAX_CHIPS = 6;

export function PickerBlock({
  block,
  onPick,
}: {
  block: SiteBlockOf<"picker">;
  onPick: (source: string, id: string) => void;
}) {
  const id = `site-picker-${block.key}`;
  const label = block.label || "Elige una opción";
  if (!block.options.length) {
    return (
      <div className="space-y-1.5">
        <p className="text-sm font-medium text-foreground">{label}</p>
        <p className="text-sm text-muted-foreground">No hay opciones disponibles.</p>
      </div>
    );
  }
  if (block.options.length > MAX_CHIPS) {
    return (
      <div className="space-y-1.5">
        <label htmlFor={id} className="text-sm font-medium text-foreground">
          {label}
        </label>
        <select
          id={id}
          className={siteFieldClass}
          value={block.selected ?? ""}
          onChange={(e) => e.target.value && onPick(block.source, e.target.value)}
        >
          {!block.selected && <option value="">Elige…</option>}
          {block.options.map((o) => (
            <option key={o.id} value={o.id}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
  return (
    <div className="space-y-2" role="radiogroup" aria-labelledby={id}>
      <p id={id} className="text-sm font-medium text-foreground">
        {label}
      </p>
      <div className="flex flex-wrap gap-2">
        {block.options.map((o) => {
          const active = o.id === block.selected;
          return (
            <button
              key={o.id}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => !active && onPick(block.source, o.id)}
              className={cn(
                "rounded-full border px-4 py-2 text-sm font-medium transition-colors",
                active
                  ? "border-primary bg-primary text-primary-foreground"
                  : "border-border bg-card text-foreground hover:bg-accent",
              )}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
